export default __webpack_public_path__ + "static/media/spot-simplified.1a305bfa.svg";